import React from 'react'
import { SplitPaymentContext } from './SplitPaymentContext'
import usePaymentContext from '../../hook/usePaymentContext'
import { useSplitPayment } from './useSplitPayment'

function SplitPaymentDialogProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const {
        onSetExpectAmount,
        onSelectPaymentType,
        orderTotalDue,
        paidPayments,
        paymentForms,
        onChangePaymentForms,
        selectedGiftCard,
        onSelectGiftCard,
        defaultPaymentType,
        onSetSplitPayment,
        addTipsMode,
        onExitAddTipsMode,
        paymentTypeLists,
    } = usePaymentContext()

    const {
        isCharging,
        onClickCharging,
        onChangePayment,
        reducePayment,
        deletePayment,
        addPayment,
        paymentCount,
        remainingAmount,
        splitEvenly,
        onFinishCharging,
        onClickBack,
    } = useSplitPayment({
        onSetExpectAmount,
        onSelectPaymentType,
        orderTotalDue,
        defaultPaymentType,
        paidPayments,
        goToSinglePayment: () => onSetSplitPayment(false),
        onChangePaymentForms,
        paymentForms,
        selectedGiftCard,
        onSelectGiftCard,
        addTipsMode,
        onExitAddTipsMode,
        paymentTypeLists,
    })

    return (
        <SplitPaymentContext.Provider
            value={{
                isCharging,
                onClickCharging,
                onChangePayment,
                reducePayment,
                deletePayment,
                addPayment,
                paymentCount,
                paymentForms,
                remainingAmount,
                splitEvenly,
                onFinishCharging,
                onClickBack,
            }}
        >
            {children}
        </SplitPaymentContext.Provider>
    )
}

export default SplitPaymentDialogProvider
